module.exports = __webpack_public_path__ + "img/react.70bb646e.svg";